<script>
import GrsDevices from "./grsDevices";
import { getContext } from "svelte";
import GRSInfo from "./GRSInfo.svelte";
  import SRSMonitor from "../components/SRSMonitor.svelte";
  import { pref as srsMonitorPref } from '../components/SRSMonitorOptions.svelte'

const flight = getContext("flight")
const replayInfo = flight.replayInfoStore;

$: selectedGRSes = Object.values($grsDevices).filter(g => g.selected)
const grsDevices = flight.getHandler(GrsDevices)
</script>

{#if selectedGRSes.length > 0 || $srsMonitorPref.showSRSMonitor}
  <div class='grsSidebar' >
    {#each selectedGRSes as grs}
      {#if grs.selected}
        <GRSInfo {grs} replaying={!$replayInfo.isFollowingHead} />  
      {/if}
    {/each}

    <SRSMonitor isSolo={false} /> 
  </div>
{/if}

<style>
  .grsSidebar {
    position: absolute;
    margin-top:58px;
    margin-right:16px;
    right: 0;
    width: 275px;
    color: white;
    background-color: rgb(37, 37, 37);
    padding: 0;
    border:1px solid black;
  }
</style>